import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { SettingsSiteControllerNeppanMainSection } from "./section";
import { SettingsSiteControllerBase } from "../../_shared/base";

import type { SiteControllerSettingBaseFormModel } from "../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingNeppanFormModel } from "../../../../model/neppan/type";
import type { SiteControllerSettingNeppanFormModelMethodsType } from "../../../../model/neppan/use-case/use-create-model/methods";

type Props = {
	hotelID: string;
	baseViewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	neppanViewModel: SiteControllerSettingNeppanFormModel["ViewModel"];
	siteControllerSettingNeppanFormModelMethodsType: SiteControllerSettingNeppanFormModelMethodsType;
};

export const SettingsSiteControllerNeppanMain = ({
	hotelID,
	baseViewModel,
	siteControllerSettingBaseFormModelMethodsType, //

	neppanViewModel,
	siteControllerSettingNeppanFormModelMethodsType,
}: Props) => {
	return (
		<FeatureIslandMainWithBackGround>
			<SettingsSiteControllerBase
				hotelID={hotelID}
				siteControllerType={baseViewModel.siteControllerType}
				siteControllerSettingBaseFormModelMethods={siteControllerSettingBaseFormModelMethodsType}
			/>
			<SettingsSiteControllerNeppanMainSection
				siteControllerSettingNeppanFormModelMethodsType={siteControllerSettingNeppanFormModelMethodsType}
				neppanViewModel={neppanViewModel}
			/>
		</FeatureIslandMainWithBackGround>
	);
};

SettingsSiteControllerNeppanMain.displayName = "SettingsSiteControllerNeppanMain";
